import { HALLOWEEN_PROMO_GIFT_COUPON } from '../campaign';

/** Coupon code for new user free shipping (first order) */
export const NEW_USER_FREESHIP_COUPON_CODE = 'newfreeship';

/** @deprecated Use NEW_USER_FREESHIP_COUPON_CODE instead */
export const FREESHIPPING_COUPON_CODE = NEW_USER_FREESHIP_COUPON_CODE;

export const COUPONS_EXEMPT_FROM_LIMIT = [NEW_USER_FREESHIP_COUPON_CODE, HALLOWEEN_PROMO_GIFT_COUPON];
